import cx from 'classnames';
import IconEdit from '../../../icons/edit';
import Link from 'next/link';
import { ReactNode, useMemo, useState } from 'react';
import dynamic from 'next/dynamic';

const VehicleSelectionModal = dynamic(
  () => import('../../../../modules/vehicle-seletion-modal'),
  {
    ssr: false,
  }
);

const PageTitleSEO = ({
  title,
  subtitle,
  textAlign,
  categoryAndSubcategory,
  allowEdit,
  titleFontClass,
  subtitleFontClass,
  contentAlign = 'flex-col',
  isSticky = false,
}: {
  title: string;
  subtitle?: string;
  categoryAndSubcategory?: ReactNode;
  textAlign?: 'center' | 'left' | 'right';
  contentAlign?: string;
  allowEdit?: boolean;
  titleFontClass?: string;
  subtitleFontClass?: string;
  isSticky?: boolean;
}) => {
  const [afterFirstRenderOpen, setAfterFirstRenderOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const As = isSticky ? 'div' : 'h1';

  return (
    <>
      {!allowEdit && (
        <>
          <div className="flex max-lg:mx-auto w-fit flex-col items-center lg:items-start gap-4">
            {categoryAndSubcategory}
            <As
              className={cx(
                textAlign === 'center'
                  ? 'text-center'
                  : textAlign === 'left'
                    ? 'text-left'
                    : textAlign === 'right'
                      ? 'text-right'
                      : 'text-center',
                'flex justify-end',
                contentAlign
              )}
            >
              <span
                className={cx(
                  subtitleFontClass
                    ? subtitleFontClass
                    : 'text-[24px] font-bold lg:text-[32px] leading-[48px]',
                  textAlign === 'center'
                    ? 'text-center'
                    : textAlign === 'left'
                      ? 'text-left'
                      : textAlign === 'right'
                        ? 'text-right'
                        : 'text-center'
                )}
              >
                <span
                  className={cx(
                    titleFontClass
                      ? titleFontClass
                      : 'font-extrabold text-3xl lg:text-5xl leading-[38px] lg:leading-[62px]'
                  )}
                >
                  {title}
                </span>
                {subtitle}
              </span>
            </As>
          </div>
        </>
      )}
      {allowEdit && (
        <>
          <div className="flex flex-col lg:flex-row items-end">
            <div className="flex max-lg:mx-auto w-fit flex-col items-center lg:items-start gap-4">
              {categoryAndSubcategory}
              <As
                className={cx(
                  'font-extrabold',
                  'text-3xl',
                  'lg:text-5xl',
                  'leading-[38px]',
                  'lg:leading-[62px]',
                  textAlign === 'center'
                    ? 'text-center'
                    : textAlign === 'left'
                      ? 'text-left'
                      : textAlign === 'right'
                        ? 'text-right'
                        : 'text-center',
                  'flex flex-col justify-end'
                )}
              >
                {title}
                <span
                  className={cx(
                    'text-[24px] font-bold',
                    'lg:text-[32px]',
                    'leading-[48px]',
                    textAlign === 'center'
                      ? 'text-center'
                      : textAlign === 'left'
                        ? 'text-left'
                        : textAlign === 'right'
                          ? 'text-right'
                          : 'text-center'
                  )}
                >
                  {subtitle}
                </span>
              </As>
            </div>

            <div
              className={cx(
                'lg:h-12 lg:pl-6 max-lg:mx-auto flex flex-row gap-4 items-center justify-center lg:justify-start',
                'cursor-pointer'
              )}
              role="button"
              onClick={() => {
                setAfterFirstRenderOpen(true);
                setIsOpen(true);
              }}
            >
              <div className={cx('grid')}>
                <IconEdit className={cx('h-4 w-4 text-bparts-100')} />
              </div>
            </div>
          </div>
          {afterFirstRenderOpen && (
            <VehicleSelectionModal
              isOpen={isOpen}
              onClose={() => setIsOpen(false)}
            />
          )}
        </>
      )}
    </>
  );
};

export default PageTitleSEO;
